<template>
   <b-card v-if="!noBusinessComponent" style="margin-bottom: 2rem">
      <div class="d-flex align-items-center justify-content-between">
         <h2 class="mb-0">Supplies</h2>

         <div class="d-flex align-items-center">
            <span id="supplies-declaration" class="mr-2">{{ suppliesDeclarationStr }}</span>
            <b-button
               id="btn-supplies"
               variant="primary"
               :to="$clientStaffRoute({name: 'supplies-table', params: {id: $companyId}})"
               :disabled="suppliesDeclaration === undefined"
            >
               View
            </b-button>
         </div>
      </div>
   </b-card>

   <CollapseCard v-else title="Supplies" ident="supplies">
      <template #subtitle>
         <span class="text-danger"> Not Configured </span>
      </template>
      <b-alert :show="true" variant="primary" class="m-3">
         <p>Supplies have not been fully configured.</p>
         <p class="mb-0">
            <b> This company has no R&D business components associated with an open study. </b>
         </p>
      </b-alert>
   </CollapseCard>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
   props: {
      noBusinessComponent: {
         type: Boolean,
      },
   },

   computed: {
      ...mapGetters({
         suppliesDeclaration: 'supplies/declaration',
      }),

      /** The company's supplies declaration */
      suppliesDeclarationStr() {
         return {
            [undefined]: 'Unconfigured',
            [null]: 'No Declaration',
            NONE: 'No Supplies',
            NOT_USA: 'Outside US',
            ONE: 'One State',
            MANY: 'Multiple States',
         }[this.suppliesDeclaration];
      },
   },
};
</script>
